import { Locale } from 'api/domains';
import httpContext from 'express-http-context';
import store from 'store';
import isServer from 'utils/isServer';

const useLocale = (): Locale => (isServer() ? httpContext.get('locale') : store.getState().app.locale) as Locale;

export default useLocale;
